import Header from '../../components/DSX/Header';

export function SSOUnauthorized() {
	return (
		<div className="sso-unauthorized">
			<Header value="Session Creation Error" />
			<h3>There was an error when starting your session. Please try again.</h3>
		</div>
	);
}
